import Fetch from "./index";

export const getApiKey = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return await Fetch("/chatbot/" + id)
}

export const getApiKeys = async (page, perPage, companyID) => {
    const params = new URLSearchParams({
        page: page ?? 1,
        perPage: perPage ?? 10,
    });
    if (companyID) params.set('companyID', companyID);
    return await Fetch(`/api-key?${params.toString()}`)
}

export const createApiKey = async (companyID) => {
    return await Fetch(
        '/api-key/',
        {
            method: 'POST',
            body: JSON.stringify({companyID}),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const deleteApiKey = async (id) => {
    return await Fetch(
        '/api-key/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}
